import { z } from 'zod';

import { makeFeatureFlagPayloadValidator } from './utils';

export const siloamPatientChartBackfill = makeFeatureFlagPayloadValidator({
  defaultEnabled: false,
  schema: z.object({
    includedTenantIds: z.array(z.string().uuid()).optional(),
    excludedTenantIds: z.array(z.string().uuid()).optional(),
  }),
  defaultValue: undefined,
});
